import {
  useTranslationsContext
} from "./chunk-Z2JTGV7P.mjs";
import {
  CloseIcon
} from "./chunk-CNSJADWA.mjs";

// src/multiselect/src/components/react-select-components/multi-value-remove.tsx
import { components } from "react-select";
import { useMemo } from "react";
import { jsx } from "react/jsx-runtime";
var MultiValueRemove = (props) => {
  const { formatAriaRemoveLabel } = useTranslationsContext();
  const ariaLabel = formatAriaRemoveLabel(props.data);
  const mappedProps = useMemo(
    () => ({
      ...props,
      innerProps: {
        ...props.innerProps,
        "aria-label": ariaLabel
      }
    }),
    [ariaLabel, props]
  );
  return /* @__PURE__ */ jsx(components.MultiValueRemove, { ...mappedProps, children: /* @__PURE__ */ jsx("span", { className: "ml-1", children: /* @__PURE__ */ jsx(CloseIcon, {}) }) });
};

export {
  MultiValueRemove
};
